/**
 * What a turn may do, and the names analytics and saved traces know it by. The
 * Ask/Do toggle (spec 2026-07-12) is gone; CompanionManager keeps one flag per
 * turn (`TurnAccess`: read-only, or may change the workspace). Events and trace
 * files recorded before the rename say 'ask' and 'do', and those stay the
 * values sent and saved, so old and new data compare. These two functions are
 * the one place that maps between the names.
 */
import type { TurnAccess } from '../types/companion'

/** The value analytics (`ai_turn.mode`) and saved trace files carry for a turn's access. */
export type WireMode = 'ask' | 'do'

/** A turn's access as analytics and traces record it. */
export function toWireMode(access: TurnAccess): WireMode {
  return access === 'change' ? 'do' : 'ask'
}

/** A recorded value as the access it stood for: anything but 'do' reads as the safe `read`. */
export function fromWireMode(mode: WireMode): TurnAccess {
  return mode === 'do' ? 'change' : 'read'
}
